import React from 'react';
import { MaskIcon } from '@/app/common/icons/MaskIcon';

const CloseIcon = ({ onClick }: { onClick?: () => void }) => (
  <MaskIcon category="Semantics" name="icon-cross" size={23} footprint={16} onClick={onClick} />
);

export default CloseIcon;
